import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);

      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const main = document.querySelector(".main-content");
      if (main) main.scrollTop = 0;
    }, 500); 

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
};

export default ScrollToTop;